import React from 'react';
import { Loader2 } from 'lucide-react';

const PageLoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-12 w-12 text-accent animate-spin" />
        <p className="text-slate-600 text-lg font-medium">Loading...</p>
      </div>
    </div>
  );
};

export default PageLoadingSpinner;
